import { render, staticRenderFns } from "./feedbackDialog.vue?vue&type=template&id=cd2a2330"
import script from "./feedbackDialog.vue?vue&type=script&lang=js"
export * from "./feedbackDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd2a2330')) {
      api.createRecord('cd2a2330', component.options)
    } else {
      api.reload('cd2a2330', component.options)
    }
    module.hot.accept("./feedbackDialog.vue?vue&type=template&id=cd2a2330", function () {
      api.rerender('cd2a2330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/QIP/feedbackDialog.vue"
export default component.exports